import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(3, 1.5),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider[7]}`,
  width: '100%',
  gap: theme.spacing(1),

  '& .MEDSInfo': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
   
  },
  '& .MADSStoreLinks': {
    display: 'flex',
    gap: theme.spacing(1),
  },

  '& .MADSStoreLink': {
    width: theme.spacing(11),
    height: theme.spacing(3),
  },

  '& .MEDSQrImgContainer': {
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1),
    width: theme.spacing(13.375),
    height: theme.spacing(13.375),
    flex: '0 0 auto',
  },
  '& .MEDSQrImg': {
    width: '100%',
    height: '100%',
  },
}));

export default StyledBox;
